import script from "./info.vue?vue&type=script&setup=true&lang=ts"
export * from "./info.vue?vue&type=script&setup=true&lang=ts"

import "./info.vue?vue&type=style&index=0&id=f084d98c&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f084d98c"]])

export default __exports__